import React from 'react';
import { connect } from 'react-redux';
import { Toolbar, ButtonGroup } from 'framework-ui-components/Components/V2';

/* 
 * Rappresenta un'estensione della Toolbar "V2" messa a disposizione tra i componenti del framework CGN,
 * nella quale vengono trattate le logiche di navigazione previste dal menu a briciole di pane.
 */
const BreadcrumbToolbar = ({
  breadcrumbs = [],
  children }) => {
  const navigaVersoBreadcrumb = (breadcrumbId) => {
    switch (breadcrumbId) {
      case 'HomeCgn':
        window.location = `${window.config.urlHome}?codiceUfficio=${ufficioSelezionato.CodiceUfficio}`;
        break;
    }
  };

  return (
    <Toolbar
      onBack={() => history.back()}
      onSelect={(breadcrumbSelezionata) => navigaVersoBreadcrumb(breadcrumbSelezionata.id)}
      breadcrumbs={breadcrumbs}
    >
      {children}
    </Toolbar>
  );
};

BreadcrumbToolbar.ButtonGroup = ButtonGroup;
BreadcrumbToolbar.Button = Toolbar.Button;

const mapStoreToProps = store => ({
  ufficioSelezionato: store.utente.ufficioSelezionato,
});

export default connect(mapStoreToProps)(BreadcrumbToolbar);
